export default __webpack_public_path__ + "static/media/fondo.dde37f56.png";